export default "__VITE_ASSET__CCApMsYe__"